import { cn } from "@/lib/utils";
export const FLOW_MODE_KEYS = ["truckload", "ltl", "drayage", "parcel", "rail", "ocean", "air"] as const;
export type FlowModeKey = (typeof FLOW_MODE_KEYS)[number];
const WHEELS = "M2.4 11.6a1.3 1.3 0 1 0 2.6 0a1.3 1.3 0 1 0 -2.6 0z M9.4 11.6a1.3 1.3 0 1 0 2.6 0a1.3 1.3 0 1 0 -2.6 0z";
const CAB = "M9 5.5h2.6L13 7.5V10H9z";
export const MODE_ICON_PATH: Record<FlowModeKey, string> = {
  truckload: `M1 3.5h7.5v6.5H1z ${CAB} ${WHEELS}`,
  ltl: `M1 3.5h7.5v6.5H1z M2.1 4.6v4.3h5.3V4.6z M2.1 6.4h2.5v2.5H2.1z ${CAB} ${WHEELS}`,
  drayage: `M1 3.5h8v6.2H1z M2.6 4.7h0.9v4h-0.9z M4.55 4.7h0.9v4h-0.9z M6.5 4.7h0.9v4h-0.9z M9.6 5.5h2.2L13 7.4v2.3H9.6z ${WHEELS}`,
  parcel: "M2.6 2.5h8.8a1.1 1.1 0 0 1 1.1 1.1v7.8a1.1 1.1 0 0 1 -1.1 1.1H2.6a1.1 1.1 0 0 1 -1.1 -1.1V3.6a1.1 1.1 0 0 1 1.1 -1.1z M1.5 5.4h11v0.9h-11z M6.1 2.5h1.8v3H6.1z",
  rail: "M3.5 1.5h7a1.5 1.5 0 0 1 1.5 1.5v7a1.5 1.5 0 0 1 -1.5 1.5h-7A1.5 1.5 0 0 1 2 10V3a1.5 1.5 0 0 1 1.5 -1.5z M4 12.2h6l1.5 1.5h-9z",
  ocean: "M1.5 7.5h11l-1.8 4.5H3.3z M4 4.5h6v3H4z M6.2 1.5h1.6v3H6.2z",
  air: "M7 0.8c0.6 0 0.9 0.8 0.9 1.8v3.3l5.3 3v1.4l-5.3-1.5v2.6l1.6 1.2v1l-2.5-0.7-2.5 0.7v-1l1.6-1.2V8.8L0.8 10.3V8.9l5.3-3V2.6c0-1 0.3-1.8 0.9-1.8z"
};
export function ModeIcon({
  mode,
  size = 14,
  className
}: {
  mode: FlowModeKey;
  size?: number;
  className?: string;
}) {
  return <svg aria-hidden="true" width={size} height={size} viewBox="0 0 14 14" className={cn("shrink-0", className)} data-sentry-element="svg" data-sentry-component="ModeIcon" data-sentry-source-file="ModeIcon.tsx">
            <path d={MODE_ICON_PATH[mode]} fill="currentColor" fillRule="evenodd" data-sentry-element="path" data-sentry-source-file="ModeIcon.tsx" />
        </svg>;
}